import { useEffect, useState } from "react";
import esriRequest from "@arcgis/core/request";

function useArcGISToken() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    async function generateToken() {
      try {
        const username = process.env.REACT_APP_ARCUSERNAME;
        const password = process.env.REACT_APP_ARCPASSWORD;

        const params = {
          username:username,
          password: password,
          client: "referer",
          referer: "https://urbangis.mp.gov.in/",
          expiration: "60",
          f: "json",
        };

        const response = await esriRequest(
          "https://mpurbangis.in/portal/sharing/rest/generateToken",
          {
            method: "post",
            query: params,
            responseType: "json",
          }
        );

        if (!response.data.token) {
          throw new Error("Token generation failed");
        }

        setToken(response.data.token);
      } catch (err) {
        console.error("Token Error:", err);
      }
    }

    generateToken();
  }, []);

  return token;
}

export default useArcGISToken;

